module.exports = __webpack_public_path__ + "static/img/historyIcon.86c6d09e.svg";